import update from "immutability-helper";

import {
  MESSAGE_TEXT_SHOW_STARTED,
  MESSAGE_TEXT_SHOW_SUCCESS,
  MESSAGE_TEXT_SHOW_FAILURE,
  MESSAGE_TEXT_SHOW_ABORTED,
  MESSAGE_TEXT_SHOW_CLOSE,
} from "@js/actions/mui/campaigns/show.js";

export default (state = {}, action) => {

  switch ( action.type ) {
  case MESSAGE_TEXT_SHOW_STARTED:
    return update(state, {
      showMessageId:      { $set: action.messageId },
      showMessageLoading: { $set: true },
      showMessageText:    { $set: null },
      showMessageError:   { $set: null },
    });
  case MESSAGE_TEXT_SHOW_SUCCESS:
    return update(state, {
      showMessageLoading: { $set: false },
      showMessageText:    { $set: action.content },
      showMessageError:   { $set: null },
    });
  case MESSAGE_TEXT_SHOW_FAILURE:
    return update(state, {
      showMessageLoading: { $set: false },
      showMessageText:    { $set: null },
      showMessageError:   { $set: action.error },
    });
  case MESSAGE_TEXT_SHOW_ABORTED:
    return state;
  case MESSAGE_TEXT_SHOW_CLOSE:
    return update(state, {
      showMessageId:      { $set: null },
      showMessageLoading: { $set: false },
      showMessageText:    { $set: null },
      showMessageError:   { $set: null },
    });
  default:
    return state;
  }

};
